import "./ResearchReports.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import Reports from "./sections/Reports";
import Spotlight from "./sections/Spotlight";
import Footer from "@/reusable_sections/Footer";
export default function ResearchReportsPage() {
  return <div>
      <Header />
      <Intro />
      <Reports />
      <Spotlight />
      <Footer />
    </div>;
}